import './setupMode'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import axios from 'axios'
import './index.css'
import './observability/frontendErrorLogger'
import App from './App.tsx'
import { setupAgentApi } from './agents'
import { GlobalErrorBoundary } from '@/components/observability/GlobalErrorBoundary'

setupAgentApi()
axios.defaults.baseURL = import.meta.env.VITE_API_URL || ''

const CHUNK_RELOAD_KEY = 'chunk-reload-attempted'
const isChunkLoadError = (error) => {
  const message = String(error ?? '')
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('Loading chunk')
  )
}

const reloadOnChunkError = (error) => {
  if (!isChunkLoadError(error)) return false
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return false
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
  window.location.reload()
  return true
}

window.addEventListener('vite:preloadError', (event) => {
  const reloading = reloadOnChunkError('vite:preloadError')
  if (reloading) {
    event.preventDefault()
  }
})

window.addEventListener('unhandledrejection', (event) => {
  reloadOnChunkError(event.reason)
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </StrictMode>,
)

sessionStorage.removeItem(CHUNK_RELOAD_KEY)
